import {
    ColoursObj,
    Icon,
    TEventrIcons,
    getContrastYIQ,
} from '@eventr/common-storybook'
import { Fab, Stack } from '@mui/material'
import hexToRgba from 'hex-to-rgba'
import { windowSizes } from '../../state/windowState/windowSignals'

interface IBottomPageFabProps {
    onClick: () => void
    icon: TEventrIcons
    id: string
    highlight?: boolean
    disabled?: boolean
}

const pulseKeyframes = `
    @keyframes pulse {
        0% {
            transform: scale(0.9);
            box-shadow: 0 0 0 0px ${hexToRgba(ColoursObj.core.secondary, 0.6)} ;
        }
        50%{
            transform: scale(1.1);
            box-shadow: 0 0 0 20px ${hexToRgba(ColoursObj.core.secondary, 0)} ;
        }
        100% {
            transform: scale(0.9);
            box-shadow: 0 0 0 0px ${hexToRgba(ColoursObj.core.secondary, 0)} ;
        }
    }
`

export const BottomPageFab = ({
    onClick,
    icon,
    id,
    highlight,
    disabled = false,
}: IBottomPageFabProps) => {
    return (
        <Stack
            flexDirection="row"
            alignItems="flex-end"
            gap="8px"
            style={{
                position: 'fixed',
                bottom: windowSizes.value.insets.insets.bottom + 100 + 'px',
                right: '16px',
                padding: '0',
            }}
        >
            <Fab
                id={id}
                size="medium"
                disabled={disabled}
                color="secondary"
                onClick={onClick}
                style={{
                    animation: highlight ? 'pulse 2.5s infinite ease' : 'none',
                    background: disabled
                        ? ColoursObj.shades.shade2
                        : ColoursObj.core.secondary,
                }}
            >
                <Icon
                    name={icon}
                    iconColour={getContrastYIQ(ColoursObj.core.secondary)}
                />
            </Fab>
            <style>{pulseKeyframes}</style>
        </Stack>
    )
}
